import { render } from "./DigitalLearningEcosystemView.vue?vue&type=template&id=599deb61&scoped=true"
import script from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"
export * from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"

import "./DigitalLearningEcosystemView.vue?vue&type=style&index=0&id=599deb61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599deb61"]])

export default __exports__